export class BookingSummaryOracle {
    constructor() {
    }

    showBookingSummary(response){
        this.bookingSummaryDiv().innerHTML = response;
    }

    cleanBookingSummary(){
        this.bookingSummaryDiv().innerHTML = '';

        return this;
    }

    bookingSummaryDiv(){
        return document.querySelector('#bookingSummary');
    }

    prevButton(){
        return document.querySelector('#bookingSummaryPrev');
    }

    addLoading(){
        this.bookingSummaryDiv().classList.add('bookingCourt--loading');

        return this;
    }

    removeLoading(){
        this.bookingSummaryDiv().classList.remove('bookingCourt--loading');

        return this;
    }
}